import React, { createElement } from 'react';
import { formatImage } from '@ifeng/public_method';
import moduleCss from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng/lowcode_tool/src/method/common'
import Chip from 'Chip';

export interface NewsList_7_Props {
    newsChip: TYPE_Chip;
    style?: object;

    mainArticleTitleStyle?: object
}

const NewsList_7: React.FC<NewsList_7_Props> = (props) => {
    const { newsChip, style, mainArticleTitleStyle } = props;

    const chipData = useChip(newsChip);
    const chipComponentData = formatChip(newsChip);

    const topItem = chipData[0];
    const bottomItems = chipData.slice(1);
    const bottomRows = [];

    bottomItems.forEach((item, index) => {
        if (index % 2 === 0) {
            bottomRows.push([item]);
        } else {
            bottomRows[bottomRows.length - 1].push(item);
        }
    });

    return chipData.length ? (
        <Chip {...chipComponentData}>
            <div className={moduleCss.wrap} style={style}>
                <div className={moduleCss.top}>
                    <a href={topItem.url} target="_blank">
                        <div className={moduleCss.topWrap}>
                            <div className={moduleCss.topLeft}>
                                <div className={moduleCss.topThumbnail}>
                                    <img src={formatImage(getThumbnailFromRecommend(topItem), 485, 223)} alt=""/>
                                </div>
                            </div>
                            <div className={moduleCss.topRight}>
                                <div className={moduleCss.topTitle} style={{ ...mainArticleTitleStyle }}>{topItem.title}</div>
                                <div className={moduleCss.topSummary}>
                                    {topItem.summary}
                                    {topItem.summary ? (
                                        <span className={moduleCss.more}>【详细】</span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div className={moduleCss.bottom}>
                    {bottomRows.length
                        ? bottomRows.map((row, index) => (
                              <div className={moduleCss.bottomRow} key={index}>
                                  {row.map((col) => {
                                      const { url, title, summary, base62Id } = col;

                                      return (
                                          <div className={moduleCss.col} key={base62Id}>
                                              <a href={url} target="_blank">
                                                  <div className={moduleCss.colWrap}>
                                                      <div className={moduleCss.colLeft}>
                                                          <div className={moduleCss.colThumbnail}>
                                                              <img src={formatImage(getThumbnailFromRecommend(col), 182, 97)} alt=""/>
                                                          </div>
                                                      </div>
                                                      <div className={moduleCss.colRight}>
                                                          <div className={moduleCss.colTitle}>
                                                              {title}
                                                          </div>
                                                          <div className={moduleCss.colSummary}>
                                                              {summary}
                                                              {summary ? (
                                                                  <span className={moduleCss.more}>
                                                                      【详细】
                                                                  </span>
                                                              ) : null}
                                                          </div>
                                                      </div>
                                                  </div>
                                              </a>
                                          </div>
                                      );
                                  })}
                              </div>
                          ))
                        : null}
                </div>
                <Mask visible={!newsChip.id} zIndex={3}>示例推荐位碎片—{newsChip.default.id}</Mask>
            </div>
        </Chip>
    ) : null;
};

export default NewsList_7;
